/** @jsx isolateComponent */

import { Fragment } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { DateTime } from '@zapier/date';
import { Spacer, Text } from '@zapier/design-system';

import { Price } from '@zapier/design-system-revenue/src/components/other/Price';
import { Currency } from '@zapier/design-system-revenue/src/types';

type Props = {
  currency: Currency;
  destinationPlanAmount: number;
  destinationPlanName: string;
  maxUses: number;
  offerEndDate: Date;
  totalCost: number;
};

export const IntroPricingActiveOfferBannerView = ({
  currency,
  destinationPlanAmount,
  destinationPlanName,
  maxUses,
  offerEndDate,
  totalCost,
}: Props) => (
  <Fragment>
    <Text tag="h3" textAlign="center" type="subtitle900">
      You're on {maxUses} months of the Zapier {destinationPlanName} plan for
      just <Price currency={currency}>{totalCost}</Price>
    </Text>

    <Spacer height={20} />

    <Text
      color="grey700"
      fontWeight={600}
      tag="p"
      textAlign="center"
      type="subtitle800"
    >
      You've unleashed the power of automation with this offer.
      <br />
      On <DateTime date={offerEndDate} />, your {destinationPlanName} plan will
      renew at <Price currency={currency}>{destinationPlanAmount}</Price>/month.
    </Text>
  </Fragment>
);
